// extracted by mini-css-extract-plugin
module.exports = {"Machine":"Machine_Machine__29u3n","content":"Machine_content__Kccmr","main":"Machine_main__89HGy"};